<template>
<div id="game">

<TitleScreen v-if="titleScreen" @launch="launch()"/>
<GameScreen v-else />

</div>
</template>

<script>
import TitleScreen from './TitleScreen.vue'
import GameScreen from './GameScreen.vue'

export default {
    name: "GameField",
    components: {
        TitleScreen,
        GameScreen
    },
    data() {
        return {
            titleScreen: true,
        }
    },
    methods: {
        launch() {
            this.titleScreen = false;
        }
    }
}
</script>

<style style="scss">
#game {
    padding: 2rem 2rem 0 2rem;
    width: 1400px;
    height: 800px;
    position: relative;
    background-image: url("../../public/background.jpg");
    border: 1px solid black;
}
</style>